(() => {
  const $navCategoryNoDropdown = $('.main-menu__nav__category:not([data-menu-id])')
  const $parent = $('.main-menu__dropdowns')
  const $dropdowns = $('.main-menu__dropdown')
  const $overlayBackground = $('.site-wrap__overlay')

  $dropdowns.each((i, el) => {
    const $el = $(el)
    const elID = $el.attr('id')
    const $trigger = $(`[data-menu-id="${elID}"]`)

    $el.dropdown({
      trigger: $trigger,
      displayEvent: 'mouseover',
      toggledClass: 'is-open',
      showCallback: showMenu,
      hideCallback: hideMenu,
      hideDelay: null,
      mouseLeaveDelay: 1,
    })

    function hideMenu() {
      $el.siblings().dropdown('hide')
      $parent.removeClass('is-open')
      $trigger.removeClass('is-open')
      if (!$parent.hasClass('is-open')) {
        $el.addClass('is-closing')
        $overlayBackground.removeClass('is-open')
      }
    }

    function showMenu() {
      $el.siblings().removeClass('is-closing')
      $parent.addClass('is-open')
      $trigger.addClass('is-open')
      $overlayBackground.addClass('is-open')
    }

    $navCategoryNoDropdown.on('mouseover', () => {
      $el.dropdown('hide')
    })
  })
})()
